import isEqual from 'lodash/isEqual';

import type { LensCard, LensCardData } from '~/types/leLens';

export function cardsShapedLikeTheirRows(
  cards: Array<LensCard>,
  rowsCards: Array<LensCard> | undefined,
  boardDataById: Map<string, LensCardData>,
  shownDataById: Map<string, LensCardData>,
): Array<LensCard> {
  if (!rowsCards) {
    return cards;
  }
  const rowsCardById = new Map(rowsCards.map((card) => [card.id, card]));
  return cards.map((card) => {
    const computed = rowsCardById.get(card.id);
    if (!computed || shownDataById.get(card.id) !== boardDataById.get(card.id)) {
      return card;
    }
    const { type, datasetId, view, period, config, filterBindings, contract } = computed;
    return { ...card, type, datasetId, view, period, config, filterBindings, contract };
  });
}

export function rowsDefinitionKey(lensId: string, lensVersion: number, viewRevision = 0): string {
  return `${lensId}:${lensVersion}:${viewRevision}`;
}

export function loadedRowsServe(saved: LensCard, draft: LensCard, rows: LensCardData | undefined): boolean {
  if (draft.datasetId !== saved.datasetId || !isEqual(draft.period ?? null, saved.period ?? null)) {
    return false;
  }
  return !rows?.aggregated || (isEqual(draft.view ?? {}, saved.view ?? {}) && draft.type === saved.type);
}
